import {
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  OnDestroy,
  RendererFactory2,
  Input,
} from '@angular/core';
import {takeUntilDestroy} from 'take-until-destroy';
import {WindowEventsService} from '../../services/window.events.service';
import {fromEventPattern} from 'rxjs';
import {filter} from "rxjs/operators";

@Directive({
  selector: '[cpClickOut]',
})
export class ClickOutDirective implements OnDestroy {
  @Input() clickOutDisable: boolean;
  @Input() ignoreMouseWheel: boolean = false;
  @Output() clickOut = new EventEmitter();

  private hostClicked = false;

  constructor(public elementRef: ElementRef, private rendererFactory2: RendererFactory2, private windowEventsService: WindowEventsService) {
    const renderer = this.rendererFactory2.createRenderer(null, null);

    let removeClickEventListener: () => void;

    const createClickEventListener = (handler: (e: Event) => boolean | void) => {
      removeClickEventListener = renderer.listen(elementRef.nativeElement, 'click', handler);
    };

    fromEventPattern<Event>(createClickEventListener, () => removeClickEventListener()).pipe(takeUntilDestroy(this)).subscribe(() => {
      this.hostClicked = true;
    });

    this.windowEventsService.onClick.pipe(takeUntilDestroy(this)).subscribe((event) => {
        if (!this.clickOutDisable && !this.hostClicked) {
          this.clickOut.emit(event);
        }
        this.hostClicked = false;
    });

    if (!this.ignoreMouseWheel) {
      this.windowEventsService.onScroll.pipe(filter((e) => !this.elementRef.nativeElement.contains(e.target))).pipe(takeUntilDestroy(this)).subscribe((event) => {
        this.clickOut.emit(event);
      });
    }
  }

  public ngOnDestroy(): void { }
}
